export default __webpack_public_path__ + "static/media/kj.540d2785.png";